import { Route } from 'react-router-dom'

import VideoRoom from './pages/VideoRoom'
import GroupVideoRoom from './pages/GroupVideoRoom'
import { PreCallTest } from './pages/PreCallTest'

const VideoCallRoutes = [
  <Route exact path="/chamada" key="/chamada" component={VideoRoom} />,
  <Route
    exact
    path="/chamada-grupo"
    key="/chamada-grupo"
    component={GroupVideoRoom}
  />,
  <Route
    exact
    path="/teste-de-chamada"
    key="/teste-de-chamada"
    component={PreCallTest}
  />,
]

export default VideoCallRoutes
